@use '@hevoio/hevo-ui-toolkit/styles/variables' as v;

// Required for virtualization: table must fill its parent and scroll internally
.virtualTable {
  height: 100%;
  overflow: auto;
}

.idBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: v.$spacer-4 v.$spacer-8;
  background: v.$bg-weak-50;
  border-radius: v.$border-radius-6;
  font-size: v.$font-size-body;
  font-weight: v.$font-weight-medium;
  line-height: v.$line-height-caption;
  color: v.$text-secondary;
  white-space: nowrap;
  flex-shrink: 0;
}

.nameCell {
  display: flex;
  flex-direction: column;
  gap: v.$spacer-2;
  overflow: hidden;
}

.namePrimary {
  font-size: v.$font-size-body-large;
  font-weight: v.$font-weight-medium;
  line-height: v.$line-height-title;
  color: v.$text-strong-950;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.084px;
}

.nameSlug {
  font-size: v.$font-size-body;
  font-weight: v.$font-weight-normal;
  line-height: v.$line-height-body;
  color: v.$text-sub-600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dateCell {
  font-size: v.$font-size-body-large;
  font-weight: v.$font-weight-medium;
  line-height: v.$line-height-title;
  color: v.$text-strong-950;
  white-space: nowrap;
  letter-spacing: -0.084px;
}

.badgePadding {
  padding: v.$spacer-4 v.$spacer-8;
}
